import { render, staticRenderFns } from "./TabsRouter.vue?vue&type=template&id=7016a19d&scoped=true&"
import script from "./TabsRouter.vue?vue&type=script&lang=js&"
export * from "./TabsRouter.vue?vue&type=script&lang=js&"
import style0 from "./TabsRouter.vue?vue&type=style&index=0&id=7016a19d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7016a19d",
  null
  
)

component.options.__file = "TabsRouter.vue"
export default component.exports